
import axios from 'axios'
// import qs from 'qs'
import store from '../store/index'
// 请求拦截器
// axios.interceptors.request.use(	
//     config=>{
// 		for(var key in userInfo['header']){
// 			config.headers[key] = userInfo['header'][key];
// 		}
//         return config;
//     },
//     function (error) {
//         return Promise.reject(error);
//     }
// );
axios.interceptors.request.use(
	config => {
    // let common = qs.parse(config.data)
	// let common = qs.parse(config.data);
	// common = Object.assign({}, window.commonData, common)
	// config.data = qs.stringify(common)
	// config.headers = Object.assign({}, window.commonHeader, config.headers)
		return config;
	},
	error => {
		return Promise.error(error);
	}
)

if (process.env.NODE_ENV == 'development') {
	axios.defaults.baseURL = 'api'
} else if (process.env.NODE_ENV == 'production') {
	// axios.defaults.baseURL = 'api'
	axios.defaults.baseURL = '//www.9xiu.com/'
}

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  //接口错误状态处理，也就是说无响应时的处理
  error => {
    return Promise.reject(error.response.status) // 返回接口返回的错误信息
})

function post (url, params) {
  return new Promise((resolve, reject) => {
		axios.post(url, params )
			.then(res => {
				if (res.data.code !== 200) {
					store.commit('saveToast', {
						bol: true,
						text: res.data.message
					})
				}
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
function get (url, params, msgBol) {
	if (!params) {
		params = ''
	}
	let initData = JSON.parse(sessionStorage.getItem('initData'))
	if (initData) {
		url+='?token='+initData.token+'&os='+initData.os+'&rid='+initData.roomID+params;
	} else {
		url+=params
	}
	return new Promise((resolve, reject) => {
		axios.get(url, params)
			.then(res => {
				if (res.data.code !== 200 && !msgBol) {
					store.commit('saveToast', {
						bol: true,
						text: res.data.message
					})
				}
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
export {
  post,
  get
}